module.exports = __webpack_public_path__ + "static/media/Sales Performance.f99d87ba.svg";